export default "__VITE_ASSET__Cnqsp8OB__"